import { Post } from '@/@types/post'
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { CACHE_POSTS_QUERY_OPTIONS } from '../fetchers/post'

export default function usePosts(ids: string[]): Post[] {
	const { data: allPosts } = useQuery(CACHE_POSTS_QUERY_OPTIONS)
	return useMemo(() => {
		return ids.map((id) => allPosts?.[id]).filter((item) => !!item) as Post[]
	}, [ids, allPosts])
}
